import { NavigateFunction, useLocation} from 'react-router-dom';

/**
 * Extracts the "backTo" URL from the query string, if present.
 * Returns `null` if not found.
 */
export const useBackUrl = (): string | null => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const backTo = params.get('backTo');
    return backTo ? decodeURIComponent(backTo) : '/accounts';
};


/**
 * Extracts and processes the "backTo" query param.
 * Redirects immediately based on origin match.
 */
export const navigateBack = (navigate: NavigateFunction) => {
    const params = new URLSearchParams(window.location.search);
    const rawBackTo = params.get('backTo');

    if (rawBackTo) {
        const backTo = decodeURIComponent(rawBackTo);
        const backToUrl = new URL(backTo, window.location.origin);
        const currentOrigin = window.location.origin;

        if (backToUrl.origin === currentOrigin) {
            // Internal route
            navigate(backToUrl.pathname + backToUrl.search + backToUrl.hash);
        } else {
            // External full redirect
            window.location.href = backTo;
        }
    } else {
        window.location.href = "/accounts"
        // Fallback: go back
        //window.history.back();
    }
};